// src/utils/widgetPatterns.ts

/**
 * Widget pattern definitions for dynamic data updates
 */
export const WIDGET_PATTERNS = {
  POPULAR_ITEMS: ['popular', 'PopularItems'],
  COMBO: ['combo', 'Combo']
} as const;

/**
 * Check if a widget type matches any of the given patterns
 * @param widgetType - The widget type to check (e.g., 'ClassicPopularItems', 'BasicCombo')
 * @param patterns - Array of patterns to match against
 * @returns true if the widget type matches any pattern
 */
export function matchesPattern(widgetType: string, patterns: readonly string[]): boolean {
  return patterns.some(pattern => 
    widgetType.toLowerCase().includes(pattern.toLowerCase())
  );
}

/**
 * Check if a widget is a popular items widget
 * @param widgetType - The widget type to check
 * @returns true if it's a popular items widget
 */
export function isPopularItemsWidget(widgetType: string): boolean {
  return matchesPattern(widgetType, WIDGET_PATTERNS.POPULAR_ITEMS);
}

/**
 * Check if a widget is a combo widget
 * @param widgetType - The widget type to check
 * @returns true if it's a combo widget
 */
export function isComboWidget(widgetType: string): boolean {
  return matchesPattern(widgetType, WIDGET_PATTERNS.COMBO);
}

/**
 * Get all widget types that match a specific pattern
 * @param widgets - Array of widgets to filter
 * @param patterns - Patterns to match
 * @returns Array of widget types that match the patterns
 */
export function getMatchingWidgetTypes(widgets: any[], patterns: readonly string[]): string[] {
  return widgets
    .filter(widget => matchesPattern(widget.type, patterns))
    .map(widget => widget.type);
}
